module.exports = __webpack_public_path__ + "img/woods_03_minified_mobile.367c7168.jpg";